import $ from 'jquery';
import { onErrorShowMessage } from '~src/errors';
import { getAxiosClient } from '~src/api';
import { addBackgroundTagToCache } from './addBackgroundTagToCache';

export const saveNewBackgroundTags = async (backgroundId, tags, isGlobal) => {
  $('#saveNewTags #editor-btn-spinner').show();
  const httpClient = await getAxiosClient();

  let table_name = '';
  if (isGlobal === true) {
    table_name = 'editor_backgrounds_default';
  } else {
    table_name = 'editor_backgrounds';
  }
  const url = `${process.env.PARSE_API_URL}/${table_name}/${backgroundId}`;
  const method = 'PUT';
  const data = {
    relations: [
      {
        column: 'tags',
        class: 'editor_images_tags',
        toIds: tags,
      },
    ],
  };
  try {
    await httpClient({ url, method, data: { data }, responseType: 'json' });
    addBackgroundTagToCache(backgroundId, tags);
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
};
